import { Dialog, DialogTitle, DialogContent, Button, Box, Typography, Grid, IconButton, TextField, Autocomplete, FormHelperText, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import React, { useState } from 'react';
import Sitc from './Sitc';
import DpItems from './DpItems';
import HotelSitc from './HotelSitc';
import BoughtOutItems from './BoughtOutItems';
import { useDispatch } from 'store';
import { RxCross2 } from "react-icons/rx";
import { useParams } from "react-router-dom";
import SoftCost from "./softCost";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import { mapAndSortAlphabetically } from "utils/mapSortHelper";
import { PROCUREMENT_TYPES } from "config";

// const PROCUREMENT_TYPES = [
//     { label: "SITC", value: "SITC" },
//     { label: "DP Items", value: "DPI" },
//     { label: "Hotel SITC", value: "HOTEL_SITC" },
//     { label: "Bought Out Items", value: "BOI" },
//     { label: "Soft Cost", value: "Soft Cost" }
// ];

const AddProcurement = (props) => {
    const { open, handleClose, actionContact } = props;
    const { projectId } = useParams();
    const dispatch = useDispatch();
    const [type, setType] = useState("SITC");

    const filteredTypes = PROCUREMENT_TYPES[projectId] || PROCUREMENT_TYPES.default;

    const handleSubmit = async ({ values, mapper }) => {
        console.log("final submit", values, mapper)
    };

    const { data: actionSubProjectRes } = useGetMasterDataQuery(
        {
            module: "ActionTracker",
            category: 'SubProject',
            ProjectId: projectId,
        }
    );

    const subProjectData = actionSubProjectRes?.data || [];
    const actionSubProjects = mapAndSortAlphabetically(subProjectData);
    const hasSubProjects = actionSubProjects?.length > 0;

    return (
        <>
            <Dialog open={open}
                fullWidth
                maxWidth="md"
                PaperProps={{
                    sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
                }}
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <DialogTitle sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "#ECECEC",
                    pb: 2,
                    pt: 3,
                    width: "100%",
                }}>
                    <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                        Add Procurement Plan
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={() => handleClose()}
                        sx={(theme) => ({
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: theme.palette.grey[500],
                        })}
                    >
                        <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <RadioGroup
                        row
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                    >
                        {filteredTypes.map((t) => (
                            <FormControlLabel
                                key={t.value}
                                value={t.value}
                                control={<Radio />}
                                label={t.label}
                            />
                        ))}
                    </RadioGroup>

                    {type === "SITC" && <Sitc tabKey="sitc" onSubmit={handleSubmit} handleClose={handleClose} actionSubProjects={actionSubProjects} />}
                    {type === "DPI" && <DpItems tabKey="dpi" onSubmit={handleSubmit} handleClose={handleClose} actionSubProjects={actionSubProjects} />}
                    {type === "HOTEL_SITC" && <HotelSitc tabKey="hotel-sitc" onSubmit={handleSubmit} handleClose={handleClose} actionSubProjects={actionSubProjects} />}
                    {type === "BOI" && <BoughtOutItems tabKey="boi" onSubmit={handleSubmit} handleClose={handleClose} actionSubProjects={actionSubProjects} />}
                    {type === "Soft Cost" && <SoftCost tabKey="soft-cost" onSubmit={handleSubmit} handleClose={handleClose} actionSubProjects={actionSubProjects} />}

                </DialogContent>
            </Dialog>
        </>
    )
}

export default AddProcurement
